/**
 *
 * Schedule - CVent Block
 *
 * Handling CVent schedule
 */

jQuery(document).ready(function () {
    const $ = jQuery;
    const cvent = new CVent();

    const scheduleBlock = $(".itbl-schedule-cvent-2024");
    const eventCode = scheduleBlock.data('event');

    if(!scheduleBlock.length) {
        return;
    }

    if(eventCode) {
        getAndPopulateSessions(eventCode);
    } else {
       return;
    }

    function getAndPopulateSessions(eventCode) {
        cvent.getSessions(eventCode).then(response => {
            const groupedSchedules = [];
            const locations = [];
            const categories = [];

            response.forEach(schedule => {
                const date = getDateInLosAngeles(schedule.start);
                const time = getTimeInLosAngeles(schedule.start);

                if(!groupedSchedules[date]) {
                    groupedSchedules[date] = [];
                }

                if(!groupedSchedules[date][time]) {
                    groupedSchedules[date][time] = [];
                }

                groupedSchedules[date][time].push(schedule);

                if(schedule.location && !locations.includes(schedule.location)) {
                    locations.push(schedule.location);
                }

                if(schedule.category && !categories.includes(schedule.category)) {
                    categories.push(schedule.category);
                }
            });

            populateSchedule(groupedSchedules);
            populateCategories(categories);
            populateLocations(locations);
        }).then(() => {
            // Add expand functionality
            $('.itbl-schedule-cvent-2024-filters__expand').on('click', function () {
                $(this).parent().toggleClass('active');
            });

            $('.itbl-schedule-cvent-2024-schedule-timeslot__session-description').each(function () {
                const $description = $(this);

                $description.on('click', function () {
                    $(this).toggleClass('expanded');
                });
            });

            // Add category filter functionality
            $('.itbl-schedule-cvent-2024__category-select').on('change', function () {
                const $scheduleItems = $(this).parent().parent().find('.itbl-single-schedule');
                const selectedCategory = $(this).val();

                $scheduleItems.each(function () {
                    const $scheduleItem = $(this);

                    if(selectedCategory === 'all') {
                        $scheduleItem.show();
                    } else {
                        if($scheduleItem.hasClass('itbl-single-schedule--category-' + selectedCategory)) {
                            $scheduleItem.show();
                        } else {
                            $scheduleItem.hide();
                        }
                    }
                });
            });

            // Add filter functionality
            $('.itbl-schedule-cvent-2024-filters__filter-tag').on('click', function () {
                const $filterTag = $(this);
                const filter = $filterTag.data('filter');
                const $filterTagParent = $filterTag.parent();
                const isActive = $filterTag.hasClass('active');
                const $timeSlots = $('.itbl-schedule-cvent-2024-schedule-timeslot');
                const $filtersWrapper = $('.itbl-schedule-cvent-2024-filters');

                $filterTagParent.find('.itbl-schedule-cvent-2024-filters__filter-tag').removeClass('active');
                $('.itbl-schedule-cvent-2024-schedule-timeslot__session').addClass('hidden');
                
                if(!isActive) {
                    $filterTag.addClass('active');
                }

                let activeFilters = [];

                $('.itbl-schedule-cvent-2024-filters__filter-tag.active').each(function () {
                    const $activeFilterTag = $(this);
                    const activeFilter = $activeFilterTag.data('filter');

                    activeFilters.push(activeFilter);
                });

                // show all sessions that match all active filters
                let filtersClasses = '';

                activeFilters.forEach(filter => {
                    filtersClasses += '.' + filter;
                });

                $('.itbl-schedule-cvent-2024-schedule-timeslot__session' + filtersClasses).removeClass('hidden');

                // if no filters are active, show all
                if($('.itbl-schedule-cvent-2024-filters__filter-tag.active').length === 0) {
                    $('.itbl-schedule-cvent-2024-schedule-timeslot__session').removeClass('hidden');
                }

                // check if all children of timeslots are hidden, if so, hide timeslot
                $timeSlots.each(function () {
                    const $timeSlot = $(this);
                    const $sessions = $timeSlot.find('.itbl-schedule-cvent-2024-schedule-timeslot__session');
                    const $hiddenSessions = $timeSlot.find('.itbl-schedule-cvent-2024-schedule-timeslot__session.hidden');

                    if($sessions.length === $hiddenSessions.length) {
                        $timeSlot.addClass('hidden');
                    } else {
                        $timeSlot.removeClass('hidden');
                    }
                });

                // check if all children of dateslots are hidden, if so, add 'No sessions' message
                $('.itbl-schedule-cvent-2024-schedule-dateslot').each(function () {
                    const $dateSlot = $(this);
                    const $timeSlots = $dateSlot.find('.itbl-schedule-cvent-2024-schedule-timeslot');
                    const $hiddenTimeSlots = $dateSlot.find('.itbl-schedule-cvent-2024-schedule-timeslot.hidden');

                    if($timeSlots.length === $hiddenTimeSlots.length) {
                        $dateSlot.find('.itbl-schedule-cvent-2024-schedule-dateslot__no-sessions').addClass('active');
                    } else {
                        $dateSlot.find('.itbl-schedule-cvent-2024-schedule-dateslot__no-sessions').removeClass('active');
                    }
                });
            });

            // Clear all filters
            $('.itbl-schedule-cvent-2024-filters__button').on('click', function () {
                $('.itbl-schedule-cvent-2024-schedule-timeslot__session.hidden').removeClass('hidden');
                $('.itbl-schedule-cvent-2024-schedule-timeslot.hidden').removeClass('hidden');
                $('.itbl-schedule-cvent-2024-schedule-dateslot__no-sessions').removeClass('active');
                $('.itbl-schedule-cvent-2024-filters__filter-tag').removeClass('active');
                $('.itbl-schedule-cvent-2024-filters__expand').parent().removeClass('active');
            });

            // Add day switch functionality
            $('.itbl-schedule-cvent-2024-dates__date').on('click', function () {
                const $date = $(this);
                const date = $date.data('date');

                $('.itbl-schedule-cvent-2024-dates__date').removeClass('active');
                $date.addClass('active');

                $('.itbl-schedule-cvent-2024-schedule-dateslot').removeClass('active');
                $('.itbl-schedule-cvent-2024-schedule-dateslot[data-date="' + date + '"]').addClass('active');
            });
        });
    }

    function getDateInLosAngeles(dateIsoString) {
        return moment(dateIsoString)
          .tz("America/Los_Angeles")
          .format('MMMM D, YYYY');
    }

    function getWeekDayInLosAngeles(dateIsoString) {
        return moment(dateIsoString)
            .format('dddd D');
    }

    function getTimeInLosAngeles(timeIsoString) {
        return moment(timeIsoString)
          .tz("America/Los_Angeles")
          .format('h:mm a');
    }

    function populateSchedule(schedules) {
        const $contentWrapper = $('.itbl-schedule-cvent-2024-schedule');
        const $datesWrapper = $('.itbl-schedule-cvent-2024-dates');
        let counter = 0;

        // sort schedules
        schedules = Object.keys(schedules).sort((a, b) => {
            return moment(a).diff(moment(b));
        }).reduce(
            (obj, key) => {
                obj[key] = schedules[key];
                return obj;
            },
            {}
        );

        for (const formattedDate in schedules) {
            var cleanDate = getWeekDayInLosAngeles(formattedDate);

            $datesWrapper.append(`
                <div class="itbl-schedule-cvent-2024-dates__date ${ !counter ? 'active' : '' }" data-date="${slugify(cleanDate)}">${cleanDate}</div>
            `);

            const $singleDateWrap = $(`
                <div class="itbl-schedule-cvent-2024-schedule-dateslot ${ !counter ? 'active' : '' }" data-date="${slugify(cleanDate)}">
                    <div class="itbl-schedule-cvent-2024-schedule-dateslot__no-sessions">No sessions</div>
                </div>
            `);

            var timeslots = schedules[formattedDate];

            // sort timeslots
            timeslots = Object.keys(timeslots).sort((a, b) => {
                return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b);
            }).reduce(
                (obj, key) => {
                    obj[key] = timeslots[key];
                    return obj;
                },
                {}
            );

            for (const key in timeslots) {
                const timeslot = timeslots[key];

                const $singleTimeWrap = $(`
                    <div class="itbl-schedule-cvent-2024-schedule-timeslot" data-time="${ slugify(key) }"></div>
                `);

                $singleTimeWrap.append(`
                    <div class="itbl-schedule-cvent-2024-schedule-timeslot__time">${ key }</div>
                `);

                $sessionsWrap = $(`
                    <div class="itbl-schedule-cvent-2024-schedule-timeslot__sessions itbl-schedule-cvent-2024-schedule-timeslot__sessions-count-${ timeslot.length }"></div>
                `);

                timeslot.forEach(schedule => {
                    const scheduleWrap = $(`
                        <div class="itbl-schedule-cvent-2024-schedule-timeslot__session ${ slugify(schedule.location) } ${ slugify(schedule.category) } ${ slugify(schedule.presentationType) }"></div>
                    `);

                    const scheduleHeader = $(`
                        <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-header">
                            <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-header-date">${ formattedDate } | ${ getTimeInLosAngeles(schedule.start) } - ${ getTimeInLosAngeles(schedule.end) }</div>
                            <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-header-location">${ schedule.location }</div>
                        </div>
                    `);

                    const mainContent = $(`
                        <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-main"></div>
                    `);

                    const scheduleTracks = $(`
                        <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-tracks">
                            <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-track ${ !schedule.category ? 'hidden' : '' } ${ slugify(schedule.category) }">${ schedule.category }</div>
                            <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-type ${ schedule.presentationType ? '' : 'hidden' }">${ schedule.presentationType }</div>
                        </div>
                    `);

                    const scheduleContent = $(`
                        <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-content">
                            <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-title">${ schedule.title }</div>
                            <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-description ${ !schedule.description ? 'no-text' : '' } ">${ schedule.description }</div>
                        </div>
                    `);

                    const scheduleSpeakers = $(`
                        <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-speakers">
                    `);

                    if(schedule.speakers.length > 0) {
                        schedule.speakers.forEach(speaker => {
                            var speakerName = speaker.firstName;
                            var speakerLastName = speaker.lastName;
                            var speakerTitle = speaker.title;
                            var speakerCompany = speaker.company;
                            var speakerPicture = speaker.profilePicture;

                            const $speaker = $(`
                            <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-speaker">
                                <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-speaker-image">
                                    <img src="${speakerPicture}" alt="${speakerName}">
                                </div>
                                <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-speaker-details">
                                    <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-speaker-name">${speakerName} ${speakerLastName}</div>
                                    <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-speaker-title">${speakerTitle}</div>
                                    <div class="itbl-schedule-cvent-2024-schedule-timeslot__session-speaker-company">${speakerCompany}</div>
                                </div>
                            </div>
                            `);

                            scheduleSpeakers.append($speaker);
                        });
                    }

                    // Append everything
                    scheduleWrap.append(scheduleHeader);
                    mainContent.append(scheduleTracks);
                    mainContent.append(scheduleContent);
                    mainContent.append(scheduleSpeakers);
                    scheduleWrap.append(mainContent);
                    $sessionsWrap.append(scheduleWrap);
                    $singleTimeWrap.append($sessionsWrap);
                });

                $singleDateWrap.append($singleTimeWrap);
            };

            $contentWrapper.append($singleDateWrap);

            counter++;
        }
    }

    function populateCategories(categories) {
        const $categoriesSelect = $('.itbl-schedule-cvent-2024-filters__category-select');

        categories.forEach(category => {
            const $categoryHtml = $(`
                <div class="itbl-schedule-cvent-2024-filters__category-select-tag itbl-schedule-cvent-2024-filters__filter-tag" data-filter="${slugify(category)}"><div>${category}</div></div>
            `);

            $categoriesSelect.append($categoryHtml);
        });
    }

    function populateLocations(locations) {
        const $locationsSelect = $('.itbl-schedule-cvent-2024-filters__location-select');

        locations.forEach(location => {
            const $locationHtml = $(`
                <div class="itbl-schedule-cvent-2024-filters__location-select-tag itbl-schedule-cvent-2024-filters__filter-tag" data-filter="${slugify(location)}"><div>${location}</div></div>
            `);

            $locationsSelect.append($locationHtml);
        });
    }

    // Helper functions
    const slugify = str =>
        str
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
});